import BillingInvoiceTemplatesAbstractEditorController from './abstract-editor-controller';

export default class BillingInvoiceTemplatesCreateController extends BillingInvoiceTemplatesAbstractEditorController {
    $onInit() {
        super.$onInit();

        this.loading = false;
    }

    doSave() {
        this.api
            .post(`billing/invoices/templates`, this.prepareModelForApi())
            .then(() => {
                this.alert.success(
                    this.translate.instant('general.alerts.create_success.title'),
                    this.translate.instant('general.alerts.create_success.content')
                )
                this.cancel();
            })
            .catch((res) => {
                this.alert.handle(res);
                this.submitting = false;
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoice_templates/controllers/pages/create-controller.js